import get from 'lodash/get';
import webApiClientSingleton from '../webApiClientSingleton';
import { categories, actions, labels } from '../player/constants/logging';
import logCategoryActionLabel from './logCategoryActionLabel';

const streamIndexMsg = 'idx';
const shoutcastHackMsg = 'shoutcastHack';
const shoutcastHackExtraTimeMsg = 'shoutcastHackExtraTime';
const m3uExtensionRemovedMsg = 'm3uExtensionRemoved';
const hlsFormatIncorrectMsg = 'hlsFormatIncorrect';

export function createStreamMessage(stream = {}) {
  const {
    index,
    isHlsFormatIncorrect,
    removedM3UExtension,
    isShoutcastHack,
    isFinalStream,
  } = stream;
  const streamDetails = [`${streamIndexMsg}=${index}`];

  if (isHlsFormatIncorrect) {
    streamDetails.push(hlsFormatIncorrectMsg);
  }

  if (removedM3UExtension) {
    streamDetails.push(m3uExtensionRemovedMsg);
  }

  if (isShoutcastHack) {
    if (isFinalStream) {
      streamDetails.push(shoutcastHackExtraTimeMsg);
    } else {
      streamDetails.push(shoutcastHackMsg);
    }
  }

  return streamDetails.join(':');
}

export function reportStreamStatus(
  listenId,
  stream = {},
  tune = {},
  err,
  duration,
  onlyHttpStreams,
) {
  const streamMessage = createStreamMessage(stream);
  const { guideId: id, itemToken, formats } = tune;
  const { id: streamGuideId, format, wasManuallyUpgradedToHttps } = stream;

  const reportData = {
    c: 'stream',
    id,
    streamGuideId,
    itemToken,
    formats,
    listenId,
    format,
    onlyHttpStreams,
  };

  if (err) {
    reportData.error = 1000;
    // NOTE: across all partners, the message query param actually denotes an error message for
    // a stream error. Hence, a separate, successMessage query param needed to be created to
    // accommodate stream success messages.
    reportData.message = `${streamMessage}|${err.message}`;
    reportData.duration = get(err, 'errorData.duration');
  } else {
    reportData.successMessage = streamMessage;
    reportData.duration = duration;
  }

  webApiClientSingleton.instance.logging.report(reportData);
  if (onlyHttpStreams || wasManuallyUpgradedToHttps) {
    logCategoryActionLabel(
      {
        category: categories.web,
        action: actions.mixedContentUpgrade,
        label: err ? labels.fail : labels.success,
      },
      {
        id,
        streamGuideId,
        itemToken,
        listenId,
        format,
      },
    );
  }
}
